import { useSearchParams } from 'react-router-dom'

type Params<T> = {
  dataIndex: keyof T
}

export const useColumnLocalFilter = <T>({ dataIndex }: Params<T>) => {
  const [searchParams] = useSearchParams()
  const filterField = searchParams.get(`filterField_${String(dataIndex)}`)
  if (!filterField) return {}

  const parseValue = (value: string) => {
    if (value === 'true') return true
    if (value === 'false') return false
    if (value === 'null') return 'null'

    const number = Number(value)
    if (!Number.isNaN(number) && value.trim() !== '') {
      return number
    }

    return value
  }

  return {
    filteredValue: filterField.split(',').map(parseValue),
  }
}
